import HeroSection from './components/HeroSection';
import ProgramSearch from './components/ProgramSearch';
import InfoSection from './components/InfoSection';
import PillarsSection from './components/PillarsSection';
import QuickLinks from './components/QuickLinks';
import PhilosophySection from './components/PhilosophySection';
import NewsEvents from './components/NewsEvents';

export default function Home() {
  return (
    <main className="overflow-x-hidden">
      <HeroSection />
      <ProgramSearch />
      <InfoSection />
      <PillarsSection />
      <QuickLinks />
      <PhilosophySection />
      <NewsEvents />
    </main>
  );
}
